(function ( $ ) {
    $.popup = {
        confirm : function(option,callback) {
            var title   = option.title || '';
            var content = option.content;

            if(title == ''){
                $('#modal-popup .modal-header').hide();
            }else{
                $('#modal-popup .modal-title').text(title);
                $('#modal-popup .modal-header').show();
            }

            $('#modal-popup .modal-body p').text(content);

            $('#modal-popup .btn.modal-confirm').off('click').click(function(){
                $('#modal-popup').modal('hide');
                return callback(true);
            });

            $('#modal-popup .modal-cancel').off('click').click(function(){
                $('#modal-popup').modal('hide');
                return callback(false);
            });

            $('#modal-popup .modal-cancel').removeClass('hidden');
            $('#modal-popup .modal-confirm').removeClass('h-auto');

            $('#modal-popup').modal('show');
        },
        warning : function(option,callback) {
            var title   = option.title || '';
            var content = option.content;

            if(title == ''){
                $('#modal-popup .modal-header').hide();
            }else{
                $('#modal-popup .modal-title').text(title);
            }

            $('#modal-popup .modal-body p').text(content);

            $('#modal-popup .btn.modal-confirm').off('click').click(function(){
                $('#modal-popup').modal('hide');
                return callback(true);
            });

            $('#modal-popup .modal-cancel').addClass('hidden');
            $('#modal-popup .modal-confirm').addClass('h-auto');

            $('#modal-popup').modal('show');
        }
    }

    $.utils = {
        copyToClipboard : function(url) {
            var $temp = $("<input>");
            $("body").append($temp);
            $temp.val(url).select();
            document.execCommand("copy");
            $temp.remove();
        },
        diffTime: function(startTimePicker, endTimePicker, totalLabel) {
            function setTotal() {
                $startTime = $('#' + startTimePicker).datetimepicker('viewDate');
                $endTime = $('#' + endTimePicker).datetimepicker('viewDate');
                $duration = moment.duration($endTime.diff($startTime));
                $milisecond = $duration.asMilliseconds();
                $('#' + totalLabel).html(moment.utc($milisecond).format('HH:mm'));
            }
            setTotal();
            $('#' + startTimePicker).on('change.datetimepicker', ({time, newTime}) => {
                setTotal();
            });
            $('#' + endTimePicker).on('change.datetimepicker', ({time, newTime}) => {
                setTotal();
            });
        }
    }

    $.fn.validateForm = function(options){
        var _self = this;
        var opts = {rules:{},messages:{}};
        $(this).find("[data-validation]").each(function(){
            var name = $(this).attr('name');
            var validations = $(this).data("validation").split("|");
            var rules = [];
            var messages = [];

            $(validations).each(function(){
                var item = this.split(":");
                if(item.length == 1){
                    item.push('true');
                }
                rules.push(item);
                var content = [];
                content.push(item[0]);
                content.push($.fn.validateForm.validation[item[0]].toString()
                    .replace(":attribute",$.fn.validateForm.validation.attributes[name])
                    .replace(":"+item[0],item[1])
                );
                messages.push(content);
            });

            // Rules
            $.extend(opts.rules,Object.fromEntries(new Map().set(name,rules.reduce(function(p, c) {
                    p[c[0]] = c[1] == "true" ? true : c[1];
                    return p;
                }, {})
            )));

            // Messsages
            $.extend(opts.messages,Object.fromEntries(new Map().set(name,messages.reduce(function(p, c) {
                    p[c[0]] = c[1];
                    return p;
                }, {})
            )));
        });
        $.extend(true, opts, options);console.log(opts);
        return $(_self).validate(opts);
    }

    $.propHooks.disabled = {
        set: function (el, value) {
            if (el.disabled !== value) {
                el.disabled = value;
                value && $(el).trigger('disabledSet');
                !value && $(el).trigger('enabledSet');
            }
        }
    };

    $.setBirthDate = function(name) {
        $currentBirthDate = $('input[name=' + name + ']').val();
        console.log('setBirthDate:' + name + '=', $currentBirthDate);
        $('input[name=' + name + ']').val($currentBirthDate == '' ? moment().subtract(18, 'year').format('YYYY') + "/01/01" : $currentBirthDate);
        $('.' + name + ' select').on('change', function() {
            $('input[name=' + name + ']').val($('.' + name + ' select').map(function() { return $(this).val() }).get().join('/'));
        });
        $('input[name=' + name + ']').on('change', function() {
            var v = $(this).val();
            console.log('birth_day hidden element changed: ', name, '(new value:' + v + ')');

            if (v) {
                var arr = v.split('/');
                $('[name=' + name + '_select_year]').val(arr[0]);
                $('[name=' + name + '_select_month]').val(arr[1]);
                $('[name=' + name + '_select_day]').val(arr[2]);
            } else {
                $('[name=' + name + '_select_year]').val(moment().subtract(18, 'year').format('YYYY'));
                $('[name=' + name + '_select_month]').val('01');
                $('[name=' + name + '_select_day]').val('01');
            }
        }).trigger('change');
        $('input[name=' + name + ']').on('disabledSet', function() {
            $('[name=' + name + '_select_year]').prop('disabled', true);
            $('[name=' + name + '_select_month]').prop('disabled', true);
            $('[name=' + name + '_select_day]').prop('disabled', true);
        });
        $('input[name=' + name + ']').on('enabledSet', function() {
            $('[name=' + name + '_select_year]').prop('disabled', false);
            $('[name=' + name + '_select_month]').prop('disabled', false);
            $('[name=' + name + '_select_day]').prop('disabled', false);
        });
    }
}( jQuery ));
